import { createSelector } from '@reduxjs/toolkit'
import { useSelector } from 'react-redux'
import { RootStoreModel } from '../store.model'

const clientsState = (store: RootStoreModel) => store.clientsState
const clientContracts = (store: RootStoreModel) => store.clientsState.clientContracts

export const selectClientData = createSelector(clientsState, state => state.clientData)

export const selectClientContracts = createSelector(clientsState, state => state.clientContracts)

export const selectClientContractByID = createSelector(
  [state => state.clientsState?.clientContracts, (state, id) => id],
  (contracts, id: number) => contracts?.find(contract => contract.id === id)
)

export const selectClientContractByCode = createSelector(
  [state => state.clientsState?.clientContracts, (state, code) => code],
  (contracts, code: string) => contracts?.find(contract => contract.contractCode === code)
)

export const selectClientCommercials = createSelector(
  clientsState,
  state => state.clientCommercials
)

export const selectActiveContract = createSelector(clientsState, state => state.activeContract)
export const selectActiveFlexibility = createSelector(
  clientsState,
  state => state.activeFlexibility
)

export const selectActiveTabAditionals = createSelector(
  clientsState,
  state => state.activeTabAditionals
)

export const selectContractProducts = createSelector(clientsState, state => state.contractProducts)

export const selectContractProductsTemp = createSelector(
  clientsState,
  state => state.contractProductsTemp
)

export const selectIsFetchingClientData = createSelector(
  clientsState,
  state => state.isFetchingClientData
)

export const selectIsFetchingClientContracts = createSelector(
  clientsState,
  state => state.isFetchingClientContracts
)

export const selectIsFetchingClientCommercials = createSelector(
  clientsState,
  state => state.isFetchingClientCommercials
)

export const selectIsFetchingClientDataError = createSelector(
  clientsState,
  state => state.isFetchingClientDataError
)

export const selectIsFetchingClientContractsError = createSelector(
  clientsState,
  state => state.isFetchingClientContractsError
)

export const selectIsFetchingClientCommercialsError = createSelector(
  clientsState,
  state => state.isFetchingClientCommercialsError
)

export const selectIsFetchingContract = createSelector(
  clientsState,
  state => state.isFetchingContract
)

export const selectIsFetchingContractError = createSelector(
  clientsState,
  state => state.isFetchingContractError
)

export const selectIsFetchingContractProducts = createSelector(
  clientsState,
  state => state.isFetchingContractProducts
)

export const selectIsFetchingContractProductsError = createSelector(
  clientsState,
  state => state.isFetchingContractProductsError
)

export const selectIsFetchingCountries = createSelector(
  clientsState,
  state => state.isFetchingCountries
)

export const selectIsFetchingCountriesError = createSelector(
  clientsState,
  state => state.isFetchingCountriesError
)

export const selectIsFetchingProvinces = createSelector(
  clientsState,
  state => state.isFetchingProvinces
)

export const selectIsFetchingProvincesError = createSelector(
  clientsState,
  state => state.isFetchingProvincesError
)

export const selectIsFetchingMunicipalities = createSelector(
  clientsState,
  state => state.isFetchingMunicipalities
)

export const selectIsFetchingMunicipalitiesError = createSelector(
  clientsState,
  state => state.isFetchingMunicipalitiesError
)

export const selectCountries = createSelector(clientsState, state => state.countries)

export const selectProvinces = createSelector(clientsState, state => state.provinces)

export const selectMunicipalities = createSelector(clientsState, state => state.municipalities)

export const useClientDependencies = () => {
  const countries = useSelector(selectCountries)
  const provinces = useSelector(selectProvinces)
  const municipalities = useSelector(selectMunicipalities)
  const isFetchingCountries = useSelector(selectIsFetchingCountries)
  const isFetchingProvinces = useSelector(selectIsFetchingProvinces)
  const isFetchingMunicipalities = useSelector(selectIsFetchingMunicipalities)
  const isFetchingCountriesError = useSelector(selectIsFetchingCountriesError)
  const isFetchingProvincesError = useSelector(selectIsFetchingProvincesError)
  const isFetchingMunicipalitiesError = useSelector(selectIsFetchingMunicipalitiesError)

  return {
    countries,
    provinces,
    municipalities,
    isFetchingCountries,
    isFetchingProvinces,
    isFetchingMunicipalities,
    isFetchingCountriesError,
    isFetchingProvincesError,
    isFetchingMunicipalitiesError
  }
}
